import { ChevronRightIcon } from '@moia-dev/pace-icons'
import { Icon, Text } from '@moia-dev/pace-web'
import { Fragment, type ReactNode } from 'react'
import { MoiaLink } from '../interactions/MoiaLink'

type BreadcrumbsConfig = {
  label: ReactNode
  to: string
}
export type BreadcrumbProps = {
  className?: string
  breadcrumbs: BreadcrumbsConfig[]
  ref?: React.Ref<HTMLElement>
}

const getKey = (to: unknown): string => {
  if (typeof to === 'string') {
    return to
  } else {
    return JSON.stringify(to)
  }
}

/**
 * https://www.w3.org/WAI/ARIA/apg/patterns/breadcrumb/examples/breadcrumb/
 */
export const Breadcrumb = ({ breadcrumbs, ref, ...props }: BreadcrumbProps) => {
  return (
    <nav
      ref={ref}
      css={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-2)',
        a: {
          textDecoration: 'none',
        },
      }}
      {...props}
    >
      {breadcrumbs.map(({ to, label }, index) =>
        index !== breadcrumbs.length - 1 ? (
          <Fragment key={getKey(to)}>
            <MoiaLink to={to}>
              <Text weight="bold">{label}</Text>{' '}
            </MoiaLink>
            <Icon size={16}>
              <ChevronRightIcon color="var(--color-content)" />
            </Icon>
          </Fragment>
        ) : (
          <MoiaLink
            css={theme => ({
              '&:hover': {
                textDecorationColor:
                  theme.semantic.ColorActionPrimaryAlternative,
              },
            })}
            to={to}
            key={getKey(to)}
            aria-current="page"
          >
            <Text
              css={theme => ({
                color: theme.semantic.ColorActionPrimaryAlternative,
              })}
              weight="bold"
            >
              {label}
            </Text>
          </MoiaLink>
        ),
      )}
    </nav>
  )
}

Breadcrumb.displayName = 'Breadcrumb'
